import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logOut', 'register', 'resetPassword'])

export const settingsComputed = {
  ...mapState('settings', {
    userSettings: (state) => state.userSettings,
    mobileFeedNotifications: (state) => state.userSettings ? state.userSettings.mobile_feed_notifications : true,
  }),
}
